<template>
    <p>By clicking CONFIRM, no new inventories can be generated for {{ item.property_name }} until you turn this off. Existing inventories are not affected.</p>
</template>

<script setup lang="ts">
import { type IProperty } from '@app/land-hold/property/models/Property';

defineProps({
    item: {
        type: Object as PropType<IProperty>,
        required: true,
    },
});
</script>
